export const LIKED_SONG = "LIKED_SONG";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const LOGGED_IN = "LOGGED_IN";
export const REJECTED_SONG = "REJECTED_SONG";
export const CREATE_PLAYLIST = "CREATE_PLAYLIST";
export const ADD_TO_PLAYLIST = "ADD_TO_PLAYLIST";
export const TOGGLE_LIKED_SONG = "TOGGLE_LIKED_SONG";
export const LOGIN= "LOGIN";
